import React from "react";
import { Link} from "react-router-dom";
import LogoGreen from "../../assets/images/smartdrive-logo-green.svg";
import twitter  from "../../assets/images/twitter.svg";
import linkedin  from "../../assets/images/linkedin.svg";
import socialNetwork  from "../../assets/images/social-network.svg";
import instagram  from "../../assets/images/instagram.svg";
import squareGreen  from "../../assets/images/square-green.svg";


const Footer = () => {
  return (<div className="footer">
    <div className="row">
      <div className="col-md-6 footer-logo">
        <Link to="/"><img src={LogoGreen} alt="Green Smart Drive Logo" /></Link>
        <p className="mt-3 fs-14 font-weight-bold footer-text">SmartDrive’s safety programs are making the world<br></br> safer and smarter - one ride at a time.</p>
      </div>
      <div className="col-md-2 fs-18 m font-weight-bold footer-item">
          <Link to="/about" className="footer-link"><img src={squareGreen} alt="Green Square" className="mr-2"/>About Us</Link>                    
      </div>
      <div className="col-md-2 fs-18 font-weight-bold footer-item">
        <Link to="/culture" className="footer-link">Culture</Link>
      </div>
      <div className="col-md-2 fs-18 font-weight-bold footer-item">
        <Link to="/careers" className="footer-link">Careers</Link><br></br>
        <small className="text-primary fs-10 font-weight-extrabold">Updated on 13 sep 2019</small>
      </div>
    </div>
    <div className="line-white"></div>
    <div className="row">
      <div className="col-md-8 fs-10 follow-us">
        SmartDrive, the SmartDrive logo, SmartDrive SmartIQ, and<br></br> Measured Safety Program are registered trademarks of<br></br> SmartDrive Systems, Inc. All other marks are the property of<br></br> their respective owners.
        <p className="text-white fs-12 pt-2 font-weight-bold">SmartDrive India is ISO 9001:2015</p>
      </div>
      <div className="col-md-4">
        <div className="row">
          <div className ="col-md-3 text-center">
            <span className="mr-4 fs-14 font-weight-bold follow">Follow Us</span>
          </div>
          <div className="col-md-9 follow-icons text-center">
            <Link to="/"><img src={twitter} alt="Twitter" className="mr-5" /></Link>
            <Link to="/"><img src={linkedin} alt="Linkedin" className="mr-5" /></Link>
            <Link to="/"><img src={socialNetwork} alt="Social Networking Site" className="mr-5" /></Link>
            <Link to="/"><img src={instagram} alt="Instagram" className="" /></Link>
          </div>
        </div>        
      </div>
    </div>
  </div> );
}
 
export default Footer;

